import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {MapConfigStateService} from "../../service/map-config-state.service";
import {catchError, exhaustMap, map, of, withLatestFrom} from "rxjs";
import {mapFilesActions} from "../actions"
import {Injectable} from "@angular/core";
import {MapFileService} from "../../service/map-file.service";
import {State as mapConfigState} from "../reducers/map-config.reducer";
import * as _ from "lodash";
import {MapFile} from "../../model/map-file";
import {DEFAULT_TILES_COLOR} from "../../consts/file.constants";
import {FileMetadata} from "../../model/file-metadata";
import {AssetType} from "../../model/user-map-file";

@Injectable()
export class MapFilesEffects {
  constructor(
    private actions$: Actions,
    private readonly store: Store,
    public mapConfigState: MapConfigStateService,
    private mapFileService: MapFileService
  ) {
  }

  loadMapFiles = createEffect(() =>
    this.actions$.pipe(
      ofType(mapFilesActions.loadFiles),
      withLatestFrom(this.store),
      exhaustMap(([action, store]) => this.mapFileService.getMapFiles().pipe(
        map(response => {
          const currentMapConfigState = (store as any).mapConfig as mapConfigState;
          if (currentMapConfigState.userMap) {
            response.forEach((mapFile: MapFile) => {
              mapFile.fileAssets = [];
              if(mapFile.points) {
                mapFile.fileAssets.push({
                  assetType: AssetType.POINT,
                  selected: false,
                  color: DEFAULT_TILES_COLOR
                });
              }
              if(mapFile.lines) {
                mapFile.fileAssets.push({
                  assetType: AssetType.LINE,
                  selected: false,
                  color: DEFAULT_TILES_COLOR
                });
              }
              if(mapFile.polygons) {
                mapFile.fileAssets.push({
                  assetType: AssetType.POLYGON,
                  selected: false,
                  color: DEFAULT_TILES_COLOR
                });
                mapFile.fileAssets.push({
                  assetType: AssetType.FILL,
                  selected: false,
                  color: DEFAULT_TILES_COLOR
                });
              }
              if (currentMapConfigState.userMap.files?.length && currentMapConfigState.userMap.files.filter(umf => umf.fileId == mapFile.fileId).length) {
                const userMapFile = currentMapConfigState.userMap.files.filter(umf => umf.fileId == mapFile.fileId)[0];
                if (userMapFile.fileAssets) {
                  userMapFile.fileAssets.forEach((fileAsset: any) => {
                    const fileAssetConfig = mapFile.fileAssets.filter(fa => fa.assetType == fileAsset.assetType)[0];
                    if (fileAssetConfig) {
                      fileAssetConfig.selected = true;
                      fileAssetConfig.color = fileAsset.color;
                    }
                  });
                }
              }
            });
          }
          return mapFilesActions.loadFilesSuccess({mapFiles: response as any})
        }),
        catchError((error: any) => of(mapFilesActions.loadFilesFailure({msg: "error"})))
      )))
  );

  getMapFileMetadata = createEffect(() =>
    this.actions$.pipe(
      ofType(mapFilesActions.getFileMetadata),
      exhaustMap(action =>
        this.mapFileService.getMapFileMetadata(action.tilesetId, action.lat, action.lon).pipe(
          map((response) => {
            return mapFilesActions.getFileMetadataSuccess({metadata: response as MapFile});
          }),
          catchError((error) => of(mapFilesActions.loadFilesFailure({msg: 'Error getting file metadata'})))
        )
      )
    )
  );

  addMapFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(mapFilesActions.addMapFile),
      exhaustMap(action =>
        this.mapFileService.addMapFile(action).pipe(
          map((response: string) => {
             return mapFilesActions.addMapFileSuccess({ mapFile: response })
          }),
          catchError(error => {
            return of(mapFilesActions.addMapFileFailure({ error: 'Error saving layer' }))
          })
        )
      )
    )
  );

  updateMapFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(mapFilesActions.updateMapFile),
      exhaustMap(action =>
        this.mapFileService.updateMapFile(action.mapFile).pipe(
          map((response: MapFile) =>
            mapFilesActions.updateMapFileSuccess({ mapFile: response })
          ),
          catchError(error =>
            of(mapFilesActions.updateMapFileFailure({ error: 'Error updating layer' }))
          )
        )
      )
    )
  );
}
